import { Link } from 'react-router-dom';

export default function StoryIntro() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
            <i className="ri-book-open-line" aria-hidden="true"></i>
            故事简介
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-900 md:text-3xl">
            一场关于「心灵之蛋」的守护冒险
          </h2>
          <div className="mt-5 space-y-4 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
            <p>
              《守护甜心》讲述了一个关于梦想与成长的故事。在每个孩子的内心深处，都藏着一颗尚未孵化的「心灵之蛋」，它承载着孩子最真实、最珍贵的愿望。当愿望足够强烈，蛋就会孵化成独一无二的「守护甜心」，成为孩子最忠诚的伙伴。
            </p>
            <p>
              主角<strong className="font-semibold text-primary-600">日奈森亚梦</strong>外表酷酷的、心里却是个爱哭鬼。某天她意外获得了多颗守护蛋，并加入了圣夜学园的守护者组织，成为传说中独一无二的「Joker」。此后，她与边里唯世、月咏几斗等伙伴一起，用「角色变换」的力量守护孩子们的心灵之蛋，直面复活社的阴谋。
            </p>
            <p>
              动画用轻松又治愈的笔触，讲述了一个个孩子找回自我、接纳不完美的故事。这也是为什么「守护甜心」能成为一代人心中最温柔的回忆。
            </p>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/characters"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-200 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              认识登场角色
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=soft%20dreamy%20pastel%20anime%20illustration%20of%20three%20glowing%20magical%20eggs%20floating%20above%20an%20open%20palm%2C%20surrounded%20by%20sakura%20petals%2C%20hearts%20and%20warm%20golden%20sparkles%2C%20symbolic%20of%20hopes%20and%20dreams%2C%20dreamy%20shoujo%20magical%20girl%20style%2C%20warm%20cream%20background%2C%20gentle%20soft%20lighting%2C%20clean%20elegant%20composition%2C%20high%20detail&width=900&height=700&seq=story-intro-01&orientation=landscape"
              alt="守护甜心心灵之蛋与樱花飘落的梦幻插画"
              className="h-64 w-full object-cover sm:h-80 md:h-[420px]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50/50 to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4">
              <p className="rounded-xl bg-background-50/85 px-4 py-3 text-sm text-foreground-700 backdrop-blur-sm">
                三颗发光的守护蛋，是亚梦命运的开始。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}